<script lang="ts">
	// Stores
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_config } from 'src/configs/devices';

	// Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { status_configurator } from 'src/helpers/device_data_helpers';

	// Components
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import PeripheralBasicDeviceDrawerV2 from 'src/components/DevicesSettings/AddonSettingsG2/PeripheralDevice/PeripheralBasicDeviceDrawerV2.svelte';
	// Types
	import type { Device } from 'src/types/Device';

	export let device: Device;
	export let statuses: unknown[] | undefined;

	const deviceConfig = devices_config?.[device?.type];

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: _statusesRaw =
		status?.online && (typeof deviceConfig !== 'undefined' || device?.type === 'peripheral-device')
			? status_configurator(status, device, settings)
			: [];
	$: _statuses = statuses ?? (Array.isArray(_statusesRaw) ? _statusesRaw : []);
</script>

<DeviceViewStateWrapper {device}>
	<div class="flex-full-height justify-content-end mt-s" slot="staticBottom">
		<PeripheralBasicDeviceDrawerV2 {device} statuses={_statuses} />
	</div>
</DeviceViewStateWrapper>
